<template>
  <div>
    <b-card id="wts-card" no-body small>
      <b-tabs id="wts-tabs" v-model="tabIndex">
        <b-tab id="wts-tab">
          <template slot="title">
            Resource
            <span class="badge badge-pill badge-primary">{{resource}}</span>
          </template>
          <wtForm>
            <template slot="left">
              <ResourceFilter></ResourceFilter>
            </template>

            <template slot="right">
              <Resource @resourceSelected="resource = $event"></Resource>
            </template>
          </wtForm>
        </b-tab>

        <b-tab id="wts-tab">
          <template slot="title">
            Resource Services
            <span class="badge badge-pill badge-primary">{{resourceService}}</span>
          </template>
          <wtForm>
            <template slot="left">
              <ResourceServiceFilter :sourceServiceType="sourceServiceType"></ResourceServiceFilter>
            </template>

            <template slot="right">
              <ResourceService
                @resourceServiceSelected="resourceService = $event"
                :sourceServiceType="sourceServiceType"
              ></ResourceService>
            </template>
          </wtForm>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/** COMPONENTS - LAYOUT **/
import wtForm from "@/components/forms/wtForm";

/** COMPONENTS **/
import Resource from "@/modules/streamline_ds/internal/resource/Resource";
import ResourceFilter from "@/modules/streamline_ds/internal/resource/ResourceFilter";
import ResourceService from "@/modules/streamline_ds/internal/resource/resource_service/ResourceService";
import ResourceServiceFilter from "@/modules/streamline_ds/internal/resource/resource_service/ResourceServiceFilter";

export default {
  name: "ResourceContainer",
  components: {
    wtForm,
    Resource,
    ResourceFilter,
    ResourceService,
    ResourceServiceFilter
  },
  computed: {
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    },
    objSelected() {
      return this.$store.state.objSelected;
    }
  },

  data: function() {
    return {
      tabIndex: null,
      resource: null,
      resourceService: null,
      sourceServiceType: [{ value: null, text: "---" }]
    };
  },
  methods: {
    alterTabFocus() {
      this.$nextTick(() => {
        this.tabIndex++;
      });
    },
    getSourceServiceTypes() {
      const urlService = "/streamline-ds/api/internal/resource-service";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-source-service-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.sourceServiceType.push({
              value: element.description,
              text: element.description
            });
          });
        });
    }
  },
  watch: {
    tabIndex() {
      if (this.tabIndex === 0) {
        this.$store.commit(
          "setUrlServicesStore",
          "streamline-ds/api/internal/resource"
        );
        this.$store.commit("setObjFilter", {});
        this.$store.commit("setObjSelected", {});
        this.$store.commit("setResetFilter", false);
        this.$store.commit("setApplyFilter", false);
      }
      if (this.tabIndex === 1) {
        this.$store.commit(
          "setUrlServicesStore",
          "streamline-ds/api/internal/resource-service"
        );
        this.$store.commit("setObjFilter", {});
        this.$store.commit("setResetFilter", false);
        this.$store.commit("setApplyFilter", false);
      }
    },

    resource() {
      if (this.resource !== null) this.alterTabFocus();
    },

    resourceService() {
      if (this.resourceService !== null) this.alterTabFocus();
    }
  },
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit(
      "setUrlServicesStore",
      "streamline-ds/api/internal/resource"
    );
  },
  mounted() {
    this.getSourceServiceTypes();
  },
  beforeDestroy() {
    this.$store.commit("setObjFilter", {});
    this.$store.commit("setResetFilter", false);
    this.$store.commit("setApplyFilter", false);
  }
};
</script>
